import type { GetScenarioBasicInfoResponseDto } from '@/types/api/scenario';

/** GET /scenario/{id}/info → 커리큘럼에 쓸 실습모드명 */
export function practiceModeLabelFromScenarioInfo(info: GetScenarioBasicInfoResponseDto): string | undefined {
	// modeValueList[0].modeValueTitle 사용 (API 문서 기준)
	const mvl = info.modeValueList;
	if (Array.isArray(mvl) && mvl.length > 0) {
		const x = mvl[0];
		const t = x?.modeValueTitle;
		if (typeof t === 'string' && t.trim()) return t.trim();
		if (t != null && String(t).trim()) return String(t).trim();
	}
	
	return undefined;
}
